import React, { useState, useContext, useEffect } from "react";
import { Minus, Plus } from "lucide-react";
import { FaTimes } from "react-icons/fa";
import './style.css';
import noImage from "../../images/no-image-product.jpg";
import { CartContext } from "../../contexts/CartContext";
import ProductVariantSelector from "../../pages/ProductDetails/ProductVariantSelector";

const ProductPopup = ({ product, onClose }) => {
    const [quantity, setQuantity] = useState(1);
    const { addToCart, showToast } = useContext(CartContext);
    const [selectedVariant, setSelectedVariant] = useState(null);

    const activeVariants = product?.productVariants?.filter(variant => variant.status === true) || [];
    const hasVariants = activeVariants.length > 0;
    const isOutOfStock = !product.status;

    if (!product) return null;

    const handleAddToCart = () => {
        if (isOutOfStock) {
            showToast("Sản phẩm không khả dụng");
            return;
        }
        if (hasVariants && !selectedVariant) {
            showToast("Vui lòng chọn kích thước và màu sắc");
            return;
        }
        addToCart({ ...product, selectedVariant, quantity });
        onClose();
    };

    const getDisplayPrice = () => {
        if (isOutOfStock) {
            return <span className="text-red-500">Hết hàng</span>;
        }
        if (hasVariants && !selectedVariant) {
            return <span className="text-red-500">Hãy chọn đủ màu và kích thước sản phẩm</span>;
        }
        if (selectedVariant?.variantId && selectedVariant.discount > 0) {
            return (
                <>
                    <span className="text-red-500">
                        {(selectedVariant.price - (selectedVariant.price * selectedVariant.discount / 100)).toLocaleString()}đ
                    </span>
                    <span className="text-gray-400 line-through ml-2">
                        {selectedVariant.price.toLocaleString()}đ
                    </span>
                </>
            );
        }
        const price = selectedVariant?.price || product.price;
        const discount = product.discount || 0;
        const finalPrice = product.priceAfterDiscount && product.priceAfterDiscount < product.price
            ? product.priceAfterDiscount
            : price - (price * discount) / 100;
        return (
            <>
                {discount > 0 ? (
                    <>
                        <span className="text-red-500">{finalPrice.toLocaleString()}đ</span>
                        <span className="text-gray-400 line-through ml-2">{price.toLocaleString()}đ</span>
                    </>
                ) : (
                    <span>{finalPrice.toLocaleString()}đ</span>
                )}
            </>
        );
    };

    return (
        <div className="popup-overlay">
            <div className="popup-content">
                <button className="close-button" onClick={onClose}>
                    <FaTimes />
                </button>
                <div className="popup-product-container">
                    <img
                        src={product.image || noImage}
                        alt={product.name}
                        className="popup-product-image"
                    />
                    <div className="popup-product-details">
                        <h3 className="popup-product-name">{product.name}</h3>
                        <p className="popup-product-price">{getDisplayPrice()}</p>
                        {hasVariants ? (
                            <ProductVariantSelector
                                product={{ ...product, productVariants: activeVariants }}
                                setSelectedVariant={setSelectedVariant}
                                initialVariant={activeVariants[0]}
                            />
                        ) : null}
                        <div className="flex items-center mt-4">
                            <button
                                onClick={() => setQuantity((prev) => Math.max(1, prev - 1))}
                                className="quantity-button"
                                disabled={isOutOfStock}
                            >
                                <Minus size={16} />
                            </button>
                            <span className="mx-3 text-lg font-semibold">{quantity}</span>
                            <button
                                onClick={() => setQuantity((prev) => prev + 1)}
                                className="quantity-button"
                                disabled={isOutOfStock}
                            >
                                <Plus size={16} />
                            </button>
                        </div>
                        <button
                            className="add-to-cart-popup"
                            onClick={handleAddToCart}
                            disabled={isOutOfStock || (hasVariants && !selectedVariant)}
                        >
                            Thêm vào giỏ hàng
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProductPopup;